import React from 'react';
import styles from './FormTechnicalProblem.scss';
import { useTranslation } from 'react-i18next';

function FormTechnicalProblem({ handleCloseModal }) {
  const { t } = useTranslation();
  return (
    <div className={styles.Overlay}>
      <div className={styles.Modal}>
        <div className={styles.CloseButton} onClick={handleCloseModal} />
        <span dangerouslySetInnerHTML={{ __html: t('components.login.formTechnicalProblem.title') }} />
      </div>
    </div>
  );
}

export default FormTechnicalProblem;



// WEBPACK FOOTER //
// ./src/components/Login/FormTechnicalProblem/FormTechnicalProblem.js